import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-modal';

Modal.setAppElement(document.getElementById('delete-modal'));

const ArchiveOption = () => <i className="fa fa-archive" aria-hidden="true"></i>;
const UnarchiveOption = () => <i className="fa fa-undo" aria-hidden="true"></i>;

export const Actions = ({ archiveAction, isActive, deleteAction, itemLabel = 'auspice' }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className="auspices-table-action-menu-container" style={{ color: 'black', flex: 0.05 }}>
      <div onClick={archiveAction} className="auspices-table-action-menu-entry" aria-label={isActive ? 'Archive' : 'Unarchive'}>
        {isActive ? <ArchiveOption /> : <UnarchiveOption />}
      </div>
      <div className="auspices-table-action-menu-entry" onClick={() => setIsModalOpen(true)} aria-label="Delete">
        <i className="fa fa-trash" aria-hidden="true" style={{ paddingLeft: 10, marginRight: 10 }}></i>
      </div>
      <Modal
        contentLabel="Delete Position"
        onRequestClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
        style={{
          content: {
            top: '50%',
            left: '50%',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            overflow: 'hidden',
            fontFamily: 'aktiv-grotesk',
            border: '1px solid #141414',
          },
        }}
      >
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>{`Are you sure you want to delete this ${itemLabel}?`}</div>
          <Button className="auspices-table-modal-button" onClick={deleteAction} bsStyle="danger">
            Yes
          </Button>
          <Button className="auspices-table-modal-button" onClick={() => setIsModalOpen(false)}>
            No
          </Button>
        </div>
      </Modal>
      <div id="delete-modal" />
    </div>
  );
};
